import {Component, OnInit} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {FormGroup, FormControl, Validators} from '@angular/forms';

@Component({
  selector: 'app-order-item',
  templateUrl: './order-item.component.html',
  styleUrls: ['./order-item.component.scss']
})
export class OrderItemComponent implements OnInit {
  paymentForm: FormGroup;
  data = {
    itemName: '',
    quantity: 1,
    total: 0
  };
  currency = 'DKK';

  constructor(
    public activeModal: NgbActiveModal
  ) {
  }

  ngOnInit() {
    this.paymentForm = new FormGroup({
      name: new FormControl(null, [
        Validators.required
      ]),
      quantity: new FormControl(null, [
        Validators.required,
        Validators.min(1)
      ]),
      total: new FormControl(null, [
        Validators.required,
        Validators.min(0)
      ]),
    });
  }

  get name() {
    return this.paymentForm.controls.name;
  }

  get quantity() {
    return this.paymentForm.controls.quantity;
  }

  get total() {
    return this.paymentForm.controls.total;
  }

  getTotal() {
    let total = 0;
    if (this.quantity.value && this.total.value) {
      total = parseFloat(this.quantity.value) * parseFloat(this.total.value);
    }
    return total;
  }

  closeModal() {
    this.activeModal.dismiss();
  }

  saveModal() {
    this.activeModal.close(this.data);
  }

  checkNumber(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && charCode !== 46 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }
}
